import {Component, Prop, Vue, Emit} from 'vue-property-decorator';

@Component
export default class LoginFooter extends Vue {
    @Prop() type!: string;
    public $router: any;
    private test: any;
}
